import { z } from 'zod';

export const vehicleSchema = z.object({
  vehicle_type_id: z.string({
    required_error: 'Le type de véhicule est requis',
  }).min(1, 'Le type de véhicule est requis'),
  
  plate_number: z.string({
    required_error: 'La plaque d\'immatriculation est requise',
  })
    .min(1, 'La plaque d\'immatriculation est requise')
    .max(20, 'La plaque ne peut pas dépasser 20 caractères')
    .regex(
      /^[A-Z0-9-]+$/,
      'Format invalide (lettres majuscules, chiffres et tirets uniquement)'
    ),
  
  vin: z.string({
    required_error: 'Le VIN est requis',
  }).min(1, 'Le VIN est requis'),
  
  brand: z.string({
    required_error: 'La marque est requise',
  })
    .min(1, 'La marque est requise')
    .max(50, 'La marque ne peut pas dépasser 50 caractères'),
  
  model: z.string({
    required_error: 'Le modèle est requis',
  })
    .min(1, 'Le modèle est requis')
    .max(50, 'Le modèle ne peut pas dépasser 50 caractères'),
  
  year: z.coerce.number({
    required_error: 'L\'année est requise',
    invalid_type_error: 'L\'année doit être un nombre',
  })
    .int('L\'année doit être un nombre entier')
    .min(1900, 'L\'année ne peut pas être avant 1900')
    .max(new Date().getFullYear() + 1, 'L\'année ne peut pas être dans le futur'),
  
  last_maintenance_date: z.date().optional().nullable(),
  
  next_maintenance_date: z.date().optional().nullable(),
}).refine(
  (data) => {
    if (data.last_maintenance_date && data.next_maintenance_date) {
      return data.next_maintenance_date > data.last_maintenance_date;
    }
    return true;
  },
  {
    message: 'Le prochain entretien doit être après le dernier entretien',
    path: ['next_maintenance_date'],
  }
);

export type VehicleFormData = z.infer<typeof vehicleSchema>;
